import { Injectable } from '@angular/core';
import {
  BookWidgetAem,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

@Injectable({
  providedIn: 'root'
})
export class BookingFlightsAdapterService {
  getContent(content: HeaderFooterMachCore): BookWidgetAem {
    return content.header.book.bookWidget;
  }
}
